import { defineStore } from 'pinia'

export const useGlobalStore = defineStore('global', {
  state: () => {
    return {
      isSidebarMinimized: false,
      dynamicBreadcrumb: '' as string | null,
    }
  },

  actions: {
    toggleSidebar() {
      this.isSidebarMinimized = !this.isSidebarMinimized
    },
    setDynamicBreadcrumb(breadcrumb: string | null) {
      this.dynamicBreadcrumb = breadcrumb
    },
  },
})
